import { jsx as n } from "react/jsx-runtime";
const i = ({ size: t, vertical: o, ...l }) => {
  const e = "auto";
  return /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: o ? t : e,
        height: o ? e : t,
        display: o ? "inline-block" : "block"
      },
      ...l
    }
  );
};
export {
  i as Spacer
};
